/*
 * 接口统一集成模块
 */
import * as tWhse from './moudules/tWhse'
import * as tClient from './moudules/tClient'
import * as tWhseControl from './moudules/tWhseControl'
import * as tItemMaster from './moudules/tItemMaster'
import * as globalOption from './moudules/globalOption'
import * as tControl from './moudules/tControl'
import * as tItemUom from './moudules/tItemUom'
import * as tPoMaster from './moudules/tPoMaster'
import * as tPoDetail from './moudules/tPoDetail'
import * as rfDialog from './moudules/rfDialog'
import * as tReceipt from './moudules/tReceipt'
import * as tStoredItem from './moudules/tStoredItem'
import * as tVendor from './moudules/tVendor'
import * as tCarrier from './moudules/tCarrier'
import * as tLocation from './moudules/tLocation'
import * as tZone from './moudules/tZone'
import * as tZoneLoca from './moudules/tZoneLoca'
import * as tOrder from './moudules/tOrder'
import * as tOrderDetail from './moudules/tOrderDetail'
import * as tWaveMaster from './moudules/tWaveMaster'
import * as tAfoWaveDetail from './moudules/tAfoWaveDetail'
import * as tAfoWaveDetailLine from './moudules/tAfoWaveDetailLine'
import * as tAfaProfile from './moudules/tAfaProfile'
import * as tAfaViewWaveOrder from './moudules/tAfaViewWaveOrder'
import * as tAfaViewWaveOrderLine from './moudules/tAfaViewWaveOrderLine'
import * as tPickDetail from './moudules/tPickDetail'
import * as tAllocation from './moudules/tAllocation'
import * as tWavePickTask from './moudules/tWavePickTask'
import * as tblCartonType from './moudules/tblCartonType'
import * as tblShippingLabel from './moudules/tblShippingLabel'
import * as tblShippingLabelDetail from './moudules/tblShippingLabelDetail'
import * as tblPrintScheduler from './moudules/tblPrintScheduler'
import * as tblSnMaster from './moudules/tblSnMaster'
import * as tblInvAdjustment from './moudules/tblInvAdjustment'
import * as tblInvAdjustmentDetail from './moudules/tblInvAdjustmentDetail'
import * as tblInvMovement from './moudules/tblInvMovement'
import * as tblInvMovementDetail from './moudules/tblInvMovementDetail'
import * as tblCycleCountTask from './moudules/tblCycleCountTask'
import * as openLink from './moudules/openLink'
import * as tblTempExcelImportInbound from './moudules/tblTempExcelImportInbound'
import * as tblTempExcelImportOutbound from './moudules/tblTempExcelImportOutbound'
import * as tblTempExcelImportInvAdjustment from './moudules/tblTempExcelImportInvAdjustment'
import * as tblTempExcelImportInvMovement from './moudules/tblTempExcelImportInvMovement'
import * as tblTempExcelImportItemMaster from './moudules/tblTempExcelImportItemMaster'
import * as tblTempExcelImportItemUom from './moudules/tblTempExcelImportItemUom'
import * as tblTempExcelImportVendor from './moudules/tblTempExcelImportVendor'
import * as tblTempExcelImportZone from './moudules/tblTempExcelImportZone'
import * as tblTempExcelImportZoneLoca from './moudules/tblTempExcelImportZoneLoca'
import * as tblTempExcelImportLocation from './moudules/tblTempExcelImportLocation'
import * as tTranLog from './moudules/tTranLog'
import * as tExceptionLog from './moudules/tExceptionLog'
import * as rfMainProcessDetail from './moudules/rfMainProcessDetail'
import * as rfSubProcessDetail from './moudules/rfSubProcessDetail'
import * as rfProcessResource from './moudules/rfProcessResource'
import * as rfSubProcessOption from './moudules/rfSubProcessOption'
import * as printJob from './moudules/printJob'

// 默认全部导出
export default {
  tWhse,
  tClient,
  tWhseControl,
  tItemMaster,
  globalOption,
  tControl,
  tItemUom,
  tPoMaster,
  tPoDetail,
  rfDialog,
  tReceipt,
  tStoredItem,
  tVendor,
  tCarrier,
  tLocation,
  tZone,
  tZoneLoca,
  tOrder,
  tOrderDetail,
  tWaveMaster,
  tAfoWaveDetail,
  tAfoWaveDetailLine,
  tAfaProfile,
  tAfaViewWaveOrder,
  tAfaViewWaveOrderLine,
  tPickDetail,
  tAllocation,
  tWavePickTask,
  tblCartonType,
  tblShippingLabel,
  tblShippingLabelDetail,
  tblPrintScheduler,
  tblSnMaster,
  tblInvAdjustment,
  tblInvAdjustmentDetail,
  tblInvMovement,
  tblInvMovementDetail,
  tblCycleCountTask,
  openLink,
  tblTempExcelImportInbound,
  tblTempExcelImportOutbound,
  tblTempExcelImportInvAdjustment,
  tblTempExcelImportInvMovement,
  tblTempExcelImportItemMaster,
  tblTempExcelImportItemUom,
  tblTempExcelImportVendor,
  tblTempExcelImportZone,
  tblTempExcelImportZoneLoca,
  tblTempExcelImportLocation,
  tTranLog,
  tExceptionLog,
  rfMainProcessDetail,
  rfSubProcessDetail,
  rfProcessResource,
  rfSubProcessOption,
  printJob
}



// WEBPACK FOOTER //
// ./src/http/wmsApi.js